import React, { useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { useTheme } from '../../../theming/useTheme';

const componentConfigurationKey = 'taboola';

interface TaboolaComponentThemeProps {
  vrLineHeight: VrLineHeight
}

type TaboolaComponentProps = TaboolaComponentThemeProps;

const createStyle = (vrLineHeight: VrLineHeight) => {
  return StyleSheet.create({
    style: {
      [MEDIA_BREAKPOINTS.LARGE]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] + 80}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 2}px`,
        paddingLeft: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
        paddingRight: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
      },
    },
  });
};

const useTaboola = () => {
  useEffect(() => {
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola = window._taboola || [];
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({
      mode: 'thumbnails-c',
      container: 'taboola-below-article-feed',
      placement: 'Below Article Feed',
      target_type: 'mix',
    });
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({ flush: true });
  }, []);
};

export const TaboolaComponent: React.FunctionComponent<TaboolaComponentProps> = React.memo(({ vrLineHeight }) => {
  useTaboola();
  const style = createStyle(vrLineHeight);
  return (
    <ErrorBoundary>
      <div className={css(style.style)} id="taboola-below-article-feed" />
    </ErrorBoundary>
  );
});


const mapThemeToProps = (theme: TaboolaComponentProps) => ({
  vrLineHeight: theme.vrLineHeight,
});

export const Taboola: React.FunctionComponent<{}> = props => {
  const themeContext = useTheme(mapThemeToProps, componentConfigurationKey);
  return <ErrorBoundary><TaboolaComponent {...themeContext} {...props} /></ErrorBoundary>;
};
